import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonFooter } from '@ionic/react'
import { getHistoryNew } from '@utils'
import { storeMobx } from 'restaurant'
import './index.scss'

const CartPreOrderFooter: FC = () => {
  const history = getHistoryNew()

  return (
    <IonFooter className='cart-pre-order-footer'>
      <div className='cart-waiter-footer'>
        <div className='cwf-wrapper'>
          <div className='cwf-info'>
            {storeMobx.info?.preOrderCustomTips ? <h3>{storeMobx.info?.preOrderCustomTips}</h3> : <h3>{i18n.t('checkout.preOrderCanScan')}<br />{i18n.t('checkout.preOrderCanScan1')}</h3>}
          </div>
          <div className='cwf-btn' data-cypid='cartPreOrderBack' onClick={() => history.goBack()}>{i18n.t('checkout.reChooseProduct')}</div>
        </div>
      </div>
    </IonFooter>
  )
}

export default observer(CartPreOrderFooter)
